import type { LeaderboardParams } from './client';
import { DEFAULT_LEADERBOARD_DIRECTION } from './models';

/**
 * Query keys of the leaderboard — a module without `'use client'`, so the
 * server render builds the same key the hook reads.
 */
export const REWARDS_LEADERBOARD_QK = ['rewards-hub', 'leaderboard'] as const;

/** One board: every tab, column, direction, period and page is its own ranking. */
export function rewardsLeaderboardKey({
  segment,
  metric,
  period,
  page,
  direction = DEFAULT_LEADERBOARD_DIRECTION,
}: LeaderboardParams) {
  return [...REWARDS_LEADERBOARD_QK, segment, metric, period, page, direction] as const;
}
